import ApiService, { HTTPMethod } from "./api.core";
import { FirebaseService, FirebaseConfigKey } from "../services/FirebaseService";


class ReportsApi {
    async getBorderauxReport(startDate,endDate,includeCharges) {
        return await ApiService.fetch(`reports/borderaux?start=${startDate.toISOString()}&end=${endDate.toISOString()}&includeCharges=${includeCharges}`, HTTPMethod.GET);
    }

    async getBrokerReport(startDate,endDate) {
      return await ApiService.fetch(`reports/broker?start=${startDate.toISOString()}&end=${endDate.toISOString()}`, HTTPMethod.GET);
    }

    async sendBorderauxToGlobal(date,transferNumber){
      return ApiService.fetch('reports/MonthlyBorderaux', HTTPMethod.POST, {
          "month": date,
          "transfer_number": transferNumber
        })
    }

    async getBorderauxToGlobalData(date,transferNumber){
      return await ApiService.fetch(`reports/MonthlyBorderaux?month=${date}&transferNumber=${transferNumber}`, HTTPMethod.GET);
    }
}

export default new ReportsApi()